export default __webpack_public_path__ + "img/73c41a4146568621c7b3ee4516bdb457.png";